var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgReleasesDark(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "releases_dark",
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_47707",
    "data-name": "Path 47707",
    d: "M0,0H24V24H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_47708",
    "data-name": "Path 47708",
    d: "M4,10.5A1.5,1.5,0,1,0,5.5,12,1.5,1.5,0,0,0,4,10.5Zm0-6A1.5,1.5,0,1,0,5.5,6,1.5,1.5,0,0,0,4,4.5Zm0,12A1.5,1.5,0,1,0,5.5,18,1.5,1.5,0,0,0,4,16.5ZM8,19H20a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2Zm0-6H20a1,1,0,0,0,0-2H8a1,1,0,0,0,0,2ZM7,6A1,1,0,0,0,8,7H20a1,1,0,0,0,0-2H8A1,1,0,0,0,7,6Z",
    fill: "#4b4e6d"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReleasesDark);
export default __webpack_public_path__ + "static/media/releases_dark.95b30f9088f8b76c99f8d15ce4b8dad2.svg";
export { ForwardRef as ReactComponent };